import Checkbox from './src/checkbox-combined';
export default Checkbox;